'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$0024anon$00245 from "./presto.-Fetcher$$anon$5.js";
import * as $j_presto$002e$002dFetcher$0024$002dDecode$002dError from "./presto.-Fetcher$-Decode-Error.js";
import * as $j_presto$002e$002dFetcher$0024$002dFetch$002dError from "./presto.-Fetcher$-Fetch-Error.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError from "./presto.-Fetcher$-Unified-Error.js";
import * as $j_presto$002econfig$0024 from "./presto.config$.js";
var $p;
function $ps_Lpresto_Fetcher$__decodeText$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lio_circe_Decoder__T__s_util_Try(req$2, res$2, x$3$1, text) {
  var x67 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_parser_package$(), text, x$3$1);
  if ((x67 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(x67.bZ);
  }
  if ((x67 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Left)) {
    var x69 = x67.gO;
    if ((x69 !== null)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(new $j_presto$002e$002dFetcher$0024$002dDecode$002dError.$c_Lpresto_Fetcher$DecodeError(x69.aN(), req$2, res$2, x69));
    }
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x67);
}
export { $ps_Lpresto_Fetcher$__decodeText$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lio_circe_Decoder__T__s_util_Try as $ps_Lpresto_Fetcher$__decodeText$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lio_circe_Decoder__T__s_util_Try };
function $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$isJson$1__Lorg_scalajs_dom_Response__Z(res$3) {
  var x75 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().jX(res$3.headers.get("content-type"));
  if ((x75 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
    var value = x75.a0;
    if ((!(!value.startsWith("application/json")))) {
      return true;
    }
  }
  return false;
}
export { $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$isJson$1__Lorg_scalajs_dom_Response__Z as $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$isJson$1__Lorg_scalajs_dom_Response__Z };
function $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$decodeError$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lcom_raquo_airstream_core_EventStream(req$3, res$4) {
  return ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_EventStream$()).nJ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sjs_js_Thenable$ThenableOps$().j3(res$4.text()).kJ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((body) => {
    var this$5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_parser_package$();
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    var x78 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$5, body, new $j_presto$002e$002dFetcher$0024$0024anon$00245.$c_Lpresto_Fetcher$$anon$5());
    if ((x78 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(new $j_presto$002e$002dFetcher$0024$002dUnified$002dError.$c_Lpresto_Fetcher$UnifiedError(x78.bZ, req$3, res$4));
    }
    if ((x78 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Left)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(new $j_presto$002e$002dFetcher$0024$002dFetch$002dError.$c_Lpresto_Fetcher$FetchError("Generic Error", req$3, res$4));
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x78);
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_concurrent_ExecutionContext$().fu()), false, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_concurrent_ExecutionContext$().fu());
}
export { $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$decodeError$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lcom_raquo_airstream_core_EventStream as $s_Lpresto_Fetcher$__presto$Fetcher$Handler$$anon$3$$_$decodeError$1__Lpresto_Fetcher$RequestBuilder__Lorg_scalajs_dom_Response__Lcom_raquo_airstream_core_EventStream };
/** @constructor */
function $c_Lpresto_Fetcher$() {
  this.aF = null;
  this.a8A = null;
  $n_Lpresto_Fetcher$ = this;
  this.aF = $j_presto$002econfig$0024.$m_Lpresto_config$().rV.DK.KO;
  this.a8A = $j_presto$002econfig$0024.$m_Lpresto_config$().rV.DK.KN;
}
export { $c_Lpresto_Fetcher$ as $c_Lpresto_Fetcher$ };
$p = $c_Lpresto_Fetcher$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$;
/** @constructor */
function $h_Lpresto_Fetcher$() {
}
export { $h_Lpresto_Fetcher$ as $h_Lpresto_Fetcher$ };
$h_Lpresto_Fetcher$.prototype = $p;
var $d_Lpresto_Fetcher$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$, "presto.Fetcher$", ({
  IA: 1
}));
export { $d_Lpresto_Fetcher$ as $d_Lpresto_Fetcher$ };
var $n_Lpresto_Fetcher$;
function $m_Lpresto_Fetcher$() {
  if ((!$n_Lpresto_Fetcher$)) {
    $n_Lpresto_Fetcher$ = new $c_Lpresto_Fetcher$();
  }
  return $n_Lpresto_Fetcher$;
}
export { $m_Lpresto_Fetcher$ as $m_Lpresto_Fetcher$ };
//# sourceMappingURL=presto.-Fetcher$.js.map
